module.exports = __webpack_public_path__ + "static/media/contact-pattern.10620abc.jpg";